export default __webpack_public_path__ + "static/media/tail-goerli.9072783d.svg";